import React from "react";
import {
  BagpackFillIcon,
  BiChartIcon,
  BiPeopleIcon,
  BiTelephoneForwardFillIcon,
  CashStackIcon,
  FemaleMaleIcon,
  FolderCheckIcon,
  FolderIcon,
  GraphUpIcon,
  People3Icon,
  PersonExclamationIcon,
  PIcon,
  RupeeIcon,
  ScanIcon,
  Target1,
  ThreeIcon,
  TrainerIcon1,
} from "../../../images/icons/icons";
import { getCardIcon } from "../../../components/common-data/Conversions";

const DashboardCard = (props) => {
  const {
    tagName,
    cardLabel,
    subLabel,
    value,
    valueAcheived,
    valueRemaining,
    checkinTypes,
    onClickCard,
    isMulti,
    isActiveCard,
    isLead,
    isPTTrack,
    filterType,
    isCardClickable,
    isFromAttendanceReport,
    isProspect,
  } = props || {};
  const formattedLabel =
    cardLabel
      ?.toLowerCase()
      ?.replace(/[^\w\s]/g, "")
      ?.replace(/ /g, "_") || "NA";

  // console.log("formattedLabel=> ", formattedLabel);

  let canClick;
  if (
    formattedLabel === "target_achieved" ||
    formattedLabel === "remaining_target" ||
    formattedLabel === "todays_sale" ||
    formattedLabel === "total_sales" ||
    formattedLabel === "sales_this_month" ||
    formattedLabel === "regular" ||
    formattedLabel === "personal_training" ||
    formattedLabel === "addon" ||
    formattedLabel === "daily_target" ||
    formattedLabel === "biomax_registered_members" ||
    formattedLabel === "total_members" ||
    formattedLabel === "assigned_members_with_trainer" ||
    formattedLabel === "not_assigned_members" ||
    formattedLabel === "biomax_registered_members" ||
    formattedLabel === "biomax_not_registered_members" ||
    formattedLabel === "pt_trial_pending" ||
    formattedLabel === "pt_trial_completed" ||
    formattedLabel === "active_members" ||
    formattedLabel === "active_ptexpired_subscription" ||
    formattedLabel === "total_trainer" ||
    formattedLabel === "total_general_trainer" ||
    formattedLabel === "total_personal_trainer" ||
    formattedLabel === "checkins" ||
    formattedLabel === "unpaid_members" ||
    formattedLabel === "expiring_today" ||
    formattedLabel === "expiring_this_month" ||
    formattedLabel === "transaction_onlineother" ||
    formattedLabel === "regular_sales_today" ||
    formattedLabel === "sales_today" ||
    formattedLabel === "pt_sales_today" ||
    tagName === "campaign-iniitiated-calls" ||
    tagName === "all" ||
    tagName === "member" ||
    tagName === "trainer" ||
    tagName === "staff" ||
    tagName === "guest" ||
    tagName === "FD_target" ||
    tagName === "pre_sales" ||
    tagName === "regular_gym_sales" ||
    isLead ||
    isPTTrack ||
    tagName === "pending-partial-payments" ||
    isCardClickable
  ) {
    canClick = true;
  } else {
    canClick = false;
  }

  // ${cardLabel && !isFromAttendanceReport ? cardLabel : ""}

  return (
    <div
      className={`dashboard-card-container ${
        tagName && !isFromAttendanceReport ? tagName : ""
      } ${
        tagName === "hot_leads" ||
        tagName === "semi_hot_leads" ||
        tagName === "warm_leads" ||
        tagName === "cold_leads" ||
        tagName === "hot_missed" ||
        tagName === "closure_expected_today" ||
        tagName === "closure_expected_tomorrow" ||
        tagName === "todays_follow_ups" ||
        tagName === "tomorrows_follow_ups" ||
        tagName === "missed_followups"
          ? "lead-type-cards"
          : ""
      } ${formattedLabel === "checkins" ? "noPadding" : ""} ${
        isActiveCard ? "active" : ""
      } ${
        tagName === "all" ||
        tagName === "member" ||
        tagName === "trainer" ||
        tagName === "staff" ||
        tagName === "guest"
          ? "aaaga-cards"
          : ""
      } 
      `}
      style={{
        cursor: canClick && onClickCard ? "pointer" : "not-allowed",
        background:
          tagName === "all"
            ? "#20221f"
            : tagName === "member"
            ? "#4E9F3D"
            : tagName === "trainer"
            ? "rgb(20, 117, 171)"
            : tagName === "staff"
            ? "rgb(245, 97, 49)"
            : tagName === "guest"
            ? "#5C527F"
            : "",
      }}
      onClick={
        canClick && onClickCard
          ? () =>
              onClickCard(
                tagName === "pending-partial-payments"
                  ? filterType
                  : tagName === "FD_target" || tagName === "BTL_leads"
                  ? tagName
                  : formattedLabel,
                tagName === "all" ||
                  tagName === "member" ||
                  tagName === "trainer" ||
                  tagName === "staff" ||
                  tagName === "guest" ||
                  isLead ||
                  isFromAttendanceReport ||
                  isProspect ||
                  tagName === "pre_sales"
                  ? tagName
                  : tagName === "tme"
                  ? filterType
                  : value
              )
          : null
      }
    >
      <div
        className={`card-top  ${
          tagName === "pre_sales" ? "" : "space-between"
        }`}
      >
        {tagName === "pre_sales" ? null : (
          <div className="card-top-content svg-img">
            {isLead || tagName === "members" ? (
              <BiPeopleIcon />
            ) : tagName === "sales" || tagName === "target-acheived" ? (
              <BiChartIcon />
            ) : tagName === "subscription" || tagName === "ure" ? (
              <RupeeIcon />
            ) : tagName === "plans" ? (
              <FolderIcon />
            ) : tagName === "transactions" ? (
              <CashStackIcon />
            ) : tagName === "cto" ? (
              <FolderCheckIcon />
            ) : tagName === "monthly-target" ? (
              <Target1 />
            ) : tagName === "campaign" ||
              tagName === "campaign-iniitiated-calls" ? (
              <BiTelephoneForwardFillIcon />
            ) : tagName === "active_pt_expired_sub" ? (
              <ScanIcon />
            ) : tagName === "all" ? (
              <FemaleMaleIcon />
            ) : tagName === "trainer" ? (
              <TrainerIcon1 />
            ) : tagName === "member" ? (
              <BagpackFillIcon />
            ) : tagName === "staff" ? (
              <People3Icon />
            ) : tagName === "guest" ? (
              <PersonExclamationIcon />
            ) : tagName === "threeday_converted_amount" ? (
              <ThreeIcon />
            ) : tagName === "pre_sales" ? (
              <PIcon />
            ) : tagName === "tme" ? (
              getCardIcon(filterType)
            ) : (
              <GraphUpIcon />
            )}
          </div>
        )}

        <div className="card-top-content card-tagline">
          <span className="card-label">
            {cardLabel} <br /> <small>{subLabel ? subLabel : null}</small>
          </span>

          {tagName === "monthly-target" ||
          tagName === "pt-target" ||
          tagName === "regular-target" ||
          tagName === "cto" ||
          isMulti ? (
            <p className="card-value">
              {valueAcheived} / {value}
              {valueRemaining ? (
                <>
                  <br />
                  <small>- {valueRemaining}</small>
                </>
              ) : null}
            </p>
          ) : (
            <p className="card-value">{value}</p>
          )}

          {tagName === "pre_sales" ? (
            <div className="presale-tag">
              <span className="pre-sale-tab">pre sale</span>
            </div>
          ) : null}
        </div>
      </div>

      {formattedLabel === "checkins" ? (
        <div className="card-bottom flex-start">
          <span className="label">
            Members:
            <b>{checkinTypes?.member?.total || 0}</b>
          </span>
          /
          <span className="label">
            Trainer:
            <b>{checkinTypes?.trainer?.total || 0}</b>
          </span>
          /
          <span className="label">
            Staff:
            <b>{checkinTypes?.staff?.total || 0}</b>
          </span>
          /
          <span className="label">
            Guest:
            <b>{checkinTypes?.guest?.total || 0}</b>
          </span>
          /
          <span className="label">
            housekeeping:
            <b>{checkinTypes?.housekeeping?.total || 0}</b>
          </span>
          /
          <span className="label">
            gym owner:
            <b>{checkinTypes?.gyms?.total || 0}</b>
          </span>
          /
          <span className="label">
            Admin:
            <b>{checkinTypes?.admin?.total || 0}</b>
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default DashboardCard;
